import {Component, Input, OnInit, ViewContainerRef} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {ApiId, TargetSystemId} from '../../../distribution-account/distribution-account.model';
import {SegmentShareComponent} from '../../share/share.component';
import {SegmentWithAccount} from '../../segments.state';

@Component({
  selector: 'app-segment-info-account-list',
  template: `
    <div class="segment-info-buttons">
      <button mat-mini-fab
              id="btn-add-target"
              data-cy="button-target-create"
              name="add-target"
              (click)="shareSegment()">
        <mat-icon>add</mat-icon>
      </button>
    </div>

    <span id="not-shared-indicator" *ngIf="selectedSegment.accounts?.length === 0" class="material-icons">
      do_not_disturb
    </span>

    <div class="target-list-container"
         data-cy="element-segment-info-target-list">
      <div class="target-container" *ngFor="let target of selectedSegment.accounts">
        <ng-container *ngFor="let account of target.accounts"
                      [ngSwitch]="account.apiId">

          <app-segment-info-target *ngSwitchCase="apiId.TTD" [account]="account"
                                   data-cy="element-segment-info-target-item">
            <app-segment-info-target-ttd [account]="account"></app-segment-info-target-ttd>
          </app-segment-info-target>
          <app-segment-info-target *ngSwitchCase="apiId.TTD_DATA_ALLIANCE" [account]="account"
                                   data-cy="element-segment-info-target-item">
            <app-segment-info-target-ttd [account]="account"></app-segment-info-target-ttd>
          </app-segment-info-target>

          <app-segment-info-target-active-agent *ngSwitchCase="apiId.ACTIVE_AGENT" [account]="account"
                                                data-cy="element-segment-info-target-item"></app-segment-info-target-active-agent>

          <app-segment-info-target [account]="account" *ngSwitchCase="apiId.XANDR"
                                   data-cy="element-segment-info-target-item">
            <app-account-xandr [account]="account"></app-account-xandr>
          </app-segment-info-target>

          <app-segment-info-target [account]="account" *ngSwitchCase="apiId.XANDR_CRTT"
                                   data-cy="element-segment-info-target-item">
            <app-account-xandr [account]="account"></app-account-xandr>
          </app-segment-info-target>

          <app-segment-info-target [account]="account" *ngSwitchCase="apiId.GOOGLE"
                                   data-cy="element-segment-info-target-item">
            <app-segment-info-google-ddp [account]="account"
                                         *ngIf="target.targetId === TargetSystemId.GOOGLE_DDP"></app-segment-info-google-ddp>
          </app-segment-info-target>
          <app-segment-info-target [account]="account" *ngSwitchCase="apiId.PUBMATIC"
                                   data-cy="element-segment-info-target-item">
            <app-account-pubmatic-edit-wrapper [account]="account"
                                               [target]="target.targetId"
                                               *ngIf="[TargetSystemId.PUBMATIC, TargetSystemId.PUBMATIC_CRTT].includes(target.targetId)">
            </app-account-pubmatic-edit-wrapper>
          </app-segment-info-target>

          <app-segment-info-target *ngSwitchDefault [account]="account"
                                   data-cy="element-segment-info-target-item"></app-segment-info-target>

          <div class="skeleton target-list-item" *ngIf="target.targetName==='loading'"></div>
          <div class="skeleton target-list-item" *ngIf="target.targetName==='loading'"></div>
          <div class="skeleton target-list-item" *ngIf="target.targetName==='loading'"></div>
        </ng-container>
      </div>
    </div>
  `,
  styleUrls: ['segment-info-account-list.component.scss']
})
export class SegmentInfoAccountListComponent implements OnInit {

  @Input() selectedSegment!: SegmentWithAccount;
  apiId = ApiId;
  TargetSystemId = TargetSystemId;
  private config!: MatDialogConfig;

  constructor(public dialog: MatDialog,
              private viewContainerRef: ViewContainerRef) {
  }

  ngOnInit() {
    this.config = new MatDialogConfig();
    this.config.viewContainerRef = this.viewContainerRef;
  }


  shareSegment() {
    this.dialog.open(SegmentShareComponent, this.config);
  }
}
